// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* games/balda/Balda.css */

.balda-board {
  position: fixed;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  width: 98%;
  max-width: 400px;
  height: calc(100% - 20px);
  max-height: 850px;

  /* Фон как в Словоделе */
  background-color: #1a1a2e;
  background-image: radial-gradient(circle at center, rgba(30, 41, 59, 0.8) 0%, rgba(15, 23, 42, 1) 100%);
  border: 4px solid #334155;
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);

  display: flex;
  flex-direction: column;
  padding: 10px;
  box-sizing: border-box;
  z-index: 6000;
  font-family: 'Courier New', monospace;
  overflow: hidden;
  -webkit-user-select: none;
          user-select: none;
  touch-action: none; /* Блокируем скролл */
}

/* ОБНОВЛЕННЫЙ HEADER (Возвращаем плотное прилегание) */
.balda-header {
  position: relative;
  z-index: 7001;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0px; /* Как было изначально */
  margin-bottom: 0px;  /* Убрали отступ - щель исчезнет */
  border-bottom: 1px solid rgba(255,255,255,0.1);
  flex-shrink: 0;
  cursor: pointer;
  transition: opacity 0.2s;
}

.balda-header:active {
  opacity: 0.7; /* Легкая прозрачность при нажатии вместо фона */
}

.balda-title {
  font-size: 18px;
  font-weight: 900;
  color: #fbbf24;
  letter-spacing: 2px;
  text-transform: uppercase;
  text-shadow: 0 0 10px rgba(251, 191, 36, 0.3);
}

.balda-stats {
  display: flex;
  gap: 12px;
  font-size: 16px;
  font-weight: bold;
  color: #cbd5e1;
}

/* INPUT AREA */
.balda-input-wrapper {
  position: relative;
  width: 100%;
  height: 46px; /* Чуть выше для комфорта */
  flex-shrink: 0;
  margin-bottom: 3px;
  display: flex;
  justify-content: center;
}

.balda-input {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  border: 2px solid #334155;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 5px 10px 0 10px; /* Чтобы текст не прилипал к краям */

  /* СТИЛИ ПО УМОЛЧАНИЮ (ДЛЯ СЛОВА) - КРУПНЫЕ И ЯРКИЕ */
  color: #ffffffdf;
  font-size: 28px; /* Еще крупнее */
  font-weight: 900;
  letter-spacing: 3px;
  text-transform: uppercase;
  box-sizing: border-box;

  /* ИСПРАВЛЕНИЕ: Убрали 'all' чтобы размер шрифта не анимировался */
  transition: border-color 0.2s, background 0.2s, color 0.1s;
}

/* СТИЛИ ДЛЯ ПОДСКАЗКИ (МЕЛКИЕ И БЛЕКЛЫЕ) */
.balda-input.is-hint {
  color: rgba(255, 255, 255, 0.5);
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: none; /* Обычный регистр для подсказок */
  font-style: italic;
  white-space: normal; /* Разрешаем перенос строк */
  line-height: 1.2;
}

/* ОБЩИЙ КЛАСС АНИМАЦИИ */
.balda-grid.shake {
  animation: shake 0.4s cubic-bezier(.36,.07,.19,.97) both;
}

/* ЦВЕТА РАМОК ПРИ ТРЯСКЕ */
.balda-grid.shake.shake-error {
  border-color: #ef4444; /* Красный */
}
.balda-grid.shake.shake-warning {
  border-color: #1d4ed8; /* Синий */
}
.balda-grid.shake.shake-neutral {
  border-color: #94a3b8; /* Серый */
}

.balda-hint-text {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.4);
  font-style: italic;
  font-weight: normal;
  letter-spacing: 0;
}

/* GRID CONTAINER */
.balda-grid-wrapper {
  flex-grow: 1; /* Занимает всё доступное место */
  display: flex;
  align-items: flex-start; /* Прижимаем к верху */
  justify-content: center;
  position: relative;
  width: 100%;
  overflow: hidden; /* Чтобы не вылезало */
  margin-top: 5px;
}

.balda-grid {
  display: grid;
  gap: 6px;
  background: #0f172a;
  padding: 8px;
  border-radius: 12px;
  border: 2px solid #334155;
  box-shadow: inset 0 0 30px rgba(0,0,0,0.6);

  /* Логика размеров: занимаем 100% ширины, но не больше доступной высоты */
  width: 100%;
  max-width: 100%; /* Ограничивается родителем */

  /* Центрируем внутри себя */
  margin: 0 auto;
  box-sizing: border-box;

  /* Плавность смены цвета рамки */
  transition: border-color 0.2s;
}

/* CELL */
.balda-cell {
  width: 100%;
  height: 100%;
  aspect-ratio: 1/1; /* Квадрат */
  box-sizing: border-box;

  background: #334155; /* Базовый цвет */
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 28px; /* Крупный шрифт */
  font-weight: 900;
  color: #f8fafc;

  cursor: pointer;
  position: relative;
  box-shadow: 0 4px 0 #1e293b; /* 3D эффект */
  transition: transform 0.1s, background-color 0.1s;
  -webkit-user-select: none;
          user-select: none;
  
}

.balda-cell:active {
  transform: translateY(2px);
  box-shadow: 0 2px 0 #1e293b;
}

/* Cell States */
.balda-cell.empty {
  background: rgba(255, 255, 255, 0.05);
  box-shadow: inset 0 2px 4px rgba(0,0,0,0.3);
  border: 2px dashed rgba(255,255,255,0.13);
}

/* СОСТОЯНИЕ: Недоступное пустое поле (скрываем) */
.balda-cell.hidden {
  background: rgba(255, 255, 255, 0.05);
  border: none;
  box-shadow: none;
  cursor: default; /* Не кликабельно визуально */
}
.balda-cell.hidden:active {
  transform: none; /* Не нажимается */
}

.balda-cell.temp {
  background: #3b82f6; /* Синий для новой буквы */
  box-shadow: 0 4px 0 #1d4ed8;
  z-index: 2;
}

.balda-cell.selected {
  background: #bfd9fa80; /* Золотой для выделения */
}

/* --- НОВОЕ: Подсветка последнего хода --- */
.balda-cell.last-move {
  position: relative;
}
/* Добавляем цветной уголок или рамку */
.balda-cell.last-move::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 2px solid #22c55e; /* Зеленая рамка */
  border-radius: 6px;
  opacity: 0.6;
  pointer-events: none;
  box-shadow: inset 0 0 5px rgba(34, 197, 94, 0.4);
}

.balda-cell.path {
  background: #fbbf24; /* Золотой для выделения */
  color: #0f172a;
  box-shadow: 0 4px 0 #b45309;
  transform: translateY(2px);
  box-shadow: 0 1px 0 #b45309; /* "Нажатое" состояние */
}

/* Подсветка последнего (головы пути) */
.balda-cell.head::after {
  content: '';
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  width: 50%; height: 50%;
  background: rgba(255,255,255,0.3);
  border-radius: 50%;
}

/* BOTTOM AREA (Controls or Keyboard) */
.balda-bottom-area {
  flex-shrink: 0;
  background: transparent;
  min-height: 50px; /* Чтобы не прыгало при смене контента */
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-top: 1px;
}

/* CONTROLS (Кнопки действий) */
.balda-controls {
  display: flex;
  gap: 12px;
  width: 100%;
}

.balda-btn {
  /* ТЕПЕРЬ ОБЕ КНОПКИ ТЯНУТСЯ */
  flex: 1 1;
  height: 50px;
  border: none;
  border-radius: 10px;

  font-family: inherit;
  font-weight: 900;
  font-size: 16px; /* Чуть меньше шрифт, чтобы влезло "Отменить" */
  text-transform: uppercase;
  color: #fff;

  cursor: pointer;
  box-shadow: 0 5px 0 rgba(0,0,0,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: all 0.1s;
}

.balda-btn:active {
  transform: translateY(3px);
  box-shadow: 0 2px 0 rgba(0,0,0,0.3);
}

.balda-btn:disabled {
  opacity: 0.5;
  filter: grayscale(1);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.btn-cancel {
  background: #334155; /* Серый slate цвет */
  box-shadow: 0 5px 0 #1e293b;
  /* Убрали flex: 0 0 ... */
}

.btn-submit {
  background: #22c55e;
  box-shadow: 0 5px 0 #15803d;
  color: #fff;
}

/* KEYBOARD */
.balda-keyboard {
  width: 100%;
  border-radius: 12px;
  padding: 0px 0px 8px 0px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px;
  animation: slideUp 0.2s ease-out;
}

@keyframes slideUp {
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.kb-key {
  /* Адаптивная ширина клавиш */
  flex: 1 0 8%;
  max-width: 9%;
  height: 42px;

  background: #f1f5f9;
  color: #0f172a;
  border-radius: 6px;
  font-weight: 800;
  font-size: 18px;
  border: none;
  box-shadow: 0 3px 0 #cbd5e1;
  cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  padding: 0;
}

.kb-key:active {
  transform: translateY(2px);
  box-shadow: 0 1px 0 #cbd5e1;
}

.kb-key.empty {
  background: transparent;
  box-shadow: none;
  cursor: default;
}

/* --- ВОЗВРАТ К ОРИГИНАЛЬНОМУ ДИЗАЙНУ ЯЗЫЧКА --- */
.balda-drawer-trigger {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: -12px;
  cursor: pointer;
  flex-shrink: 0;
  z-index: 1000;
}

.balda-drawer-btn-small {
  background: #334155;
  color: #fbbf24;
  border: 1px solid #475569;
  border-top: none;
  border-radius: 0 0 12px 12px;
  padding: 2px 20px;
  font-size: 16px;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0,0,0,0.3);
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.balda-drawer-btn-small:hover {
  background: #475569;
  padding-top: 5px; /* Эффект вытягивания */
}

/* ОБНОВЛЕННАЯ ШТОРКА (Уменьшили внутренние отступы) */
.balda-drawer {
  position: absolute;
  top: 30;
  left: 0;
  width: 100%;
  height: auto;
  min-height: 50%;
  max-height: 100%;

  /* Верхний отступ ровно под высоту однострочного хедера (35px) */
  padding: 35px 10px 10px 10px;

  background: rgba(15, 23, 42, 0.98);
  backdrop-filter: blur(10px);
  z-index: 7000;
  border-bottom: 4px solid #fbbf24;
  border-radius: 0 0 16px 16px;
  box-shadow: 0 20px 50px rgba(0,0,0,0.8);

  transform: translateY(-120%);
  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.balda-drawer.open {
  transform: translateY(20px);
}

.balda-drawer-content {
  flex-grow: 1;
  overflow-y: auto;
  padding-right: 5px;
  margin-bottom: 10px;
  /* Скроллбар */
  scrollbar-width: thin;
  scrollbar-color: #334155 transparent;
}

.balda-drawer-footer {
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  padding-top: 10px;
  border-top: 1px solid rgba(255,255,255,0.1);
}

.balda-close-drawer-btn {
  background: #fbbf24;
  color: #0f172a;
  border: none;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(251, 191, 36, 0.4);
  transition: transform 0.2s;
}
.balda-close-drawer-btn:active {
  transform: scale(0.9);
}

/* Компактная панель определения слова */
.balda-definition-panel {
    background: rgba(251, 191, 36, 0.12);
    border: 1px solid rgba(251, 191, 36, 0.3);
    border-radius: 8px;
    padding: 8px 10px;
    margin-bottom: 10px;
    cursor: pointer;
    animation: fadeIn 0.3s ease-out;
}
@keyframes fadeIn { from { opacity: 0; transform: translateY(-5px); } to { opacity: 1; transform: translateY(0); } }

.balda-def-word {
    display: block;
    font-weight: 900;
    color: #fbbf24;
    text-transform: uppercase;
    font-size: 15px;
    margin-bottom: 4px;
    border-bottom: 1px solid rgba(251, 191, 36, 0.2);
    padding-bottom: 2px;
}
.balda-def-text {
    font-size: 13px;
    line-height: 1.5;
    color: #f1f5f9;
    font-family: sans-serif;
}
.balda-empty-list {
  text-align: center;
  color: #64748b;
  font-style: italic;
  margin-top: 40px;
}

.balda-words-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-content: flex-start;
}

.balda-word-tag {
  background: rgba(255, 255, 255, 0.05);
  color: #e2e8f0;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  border: 1px solid transparent;
  transition: all 0.2s;
}
.balda-word-tag:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255,255,255,0.2);
}
.balda-word-tag.has-def {
  border-bottom: 1px solid rgba(251, 191, 36, 0.5);
  color: #fff;
}
.balda-word-help-icon {
  font-size: 10px;
  color: #fbbf24;
  margin-left: 6px;
  opacity: 0.8;
}

/* --- ПЕЧАТИ (STAMPS) --- */
.balda-stamp-overlay {
  position: absolute;
  top: 15%; /* Подняли выше (верхняя треть) */
  left: 0; right: 0;
  height: 100px;
  display: flex; align-items: center; justify-content: center;
  pointer-events: none; /* Пропускает клики */
  background: transparent;
  z-index: 100;
}

.balda-stamp {
  /* УВЕЛИЧЕНО В ~1.5 РАЗА */
  padding: 15px 30px;
  font-size: 34px;
  font-weight: 900;
  text-transform: uppercase;
  border: 8px double; /* Рамка толще */
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.85);
  opacity: 0.8;
  box-shadow: 0 6px 20px rgba(0,0,0,0.3);
  transform: rotate(-10deg) scale(2);
  opacity: 0;
  animation: baldaStampIn 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;

  text-align: center;
  white-space: pre-wrap;
  max-width: 90%;
  line-height: 1.1;
}

@keyframes baldaStampIn {
  to { transform: rotate(-10deg) scale(1); opacity: 1; }
}

.stamp-ok { color: #15803d; border-color: #15803d; }
.stamp-fail { color: #b91c1c; border-color: #b91c1c; }
.stamp-warning { color: #1d4ed8; border-color: #1d4ed8; }

/* Tряска */
@keyframes shake {
  10%, 90% { transform: translateX(-2px); }
  20%, 80% { transform: translateX(4px); }
  30%, 50%, 70% { transform: translateX(-6px); }
  40%, 60% { transform: translateX(6px); }
}

/* Добавить в конец файла, если стили отчета не подтягиваются глобально */

.tr-report-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 8000; /* Поверх всего */
  animation: fadeIn 0.3s ease-out;
  padding: 20px;
  box-sizing: border-box;
}

.tr-report-card {
  width: 100%;
  max-width: 360px;
  background-color: #f0e6cf; /* Стиль папки */
  padding: 30px 25px;
  border-radius: 4px;
  box-shadow: 0 20px 50px rgba(0,0,0,0.8);
  transform: rotate(-1deg);
  position: relative;
  display: flex;
  flex-direction: column;
  color: #222;
}

.tr-watermark {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  font-size: 60px;
  font-weight: 900;
  color: rgba(0,0,0,0.05);
  pointer-events: none;
  white-space: nowrap;
}

.tr-report-header {
  border-bottom: 3px solid #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  text-align: center;
}

.tr-report-title {
  font-size: 24px;
  font-weight: 900;
  text-transform: uppercase;
  color: #1a1a1a;
}

.tr-stats-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
}

.tr-stat-row {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgba(0,0,0,0.1);
  padding-bottom: 4px;
}

.tr-stat-label { font-size: 13px; font-weight: 700; color: #666; }
.tr-stat-value { font-size: 20px; font-weight: 900; color: #111; }

.tr-result-stamp {
  margin: 10px auto;
  padding: 8px 20px;
  font-size: 28px;
  font-weight: 900;
  text-transform: uppercase;
  border: 5px double;
  border-radius: 8px;
  transform: rotate(-10deg);
  opacity: 0.9;
  align-self: center;
}
.stamp-ok { color: #15803d; border-color: #15803d; }
.stamp-fail { color: #b91c1c; border-color: #b91c1c; }

.tr-btn-group {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.tr-btn {
  border: none;
  padding: 14px 0;
  width: 100%;
  font-weight: 900;
  text-transform: uppercase;
  cursor: pointer;
  border-radius: 4px;
  display: flex; justify-content: center; align-items: center;
}
.tr-btn-primary { background: #222; color: #f0e6cf; }
.tr-btn-secondary { background: transparent; border: 2px solid #444; color: #333; }

/* Переопределяем анимацию только для серой (нейтральной) тряски */
.balda-grid.shake.shake-neutral {
  animation-name: shake-soft;
}

/* Новая мягкая анимация (амплитуда уменьшена в ~3 раза: с 6px до 2px) */
@keyframes shake-soft {
  10%, 90% { transform: translateX(-0.5px); }
  20%, 80% { transform: translateX(0.5px); }
  30%, 50%, 70% { transform: translateX(-1px); }
  40%, 60% { transform: translateX(1px); }
}

/* Вспышка поля при передаче хода */
@keyframes myTurnFlash {
    0% { box-shadow: inset 0 0 30px rgba(0,0,0,0.6), 0 0 0 0px rgba(34, 197, 94, 0); }
    50% { box-shadow: inset 0 0 30px rgba(0,0,0,0.6), 0 0 20px 5px rgba(34, 197, 94, 0.8); border-color: #22c55e; }
    100% { box-shadow: inset 0 0 30px rgba(0,0,0,0.6), 0 0 0 0px rgba(34, 197, 94, 0); }
}

.balda-grid.my-turn-flash {
    animation: myTurnFlash 1s ease-out;
}

.balda-turn-toast {
    position: absolute;
    top: 20%;
    left: 50%;
    transform: translateX(-50%);
    background: linear-gradient(90deg, transparent, rgba(34, 197, 94, 0.95), transparent);
    color: white;
    padding: 10px 60px;
    font-size: 24px;
    font-weight: 900;
    letter-spacing: 2px;
    z-index: 4000;
    pointer-events: none;
    text-shadow: 0 2px 5px rgba(0,0,0,0.8);
    animation: turnToastAnim 1.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
}

@keyframes turnToastAnim {
    0% { opacity: 0; transform: translate(-50%, -30px) scale(0.8); }
    20% { opacity: 1; transform: translate(-50%, 0) scale(1); }
    80% { opacity: 1; transform: translate(-50%, 0) scale(1); }
    100% { opacity: 0; transform: translate(-50%, 20px) scale(0.8); }
}

/* DUEL MODE STYLES */

/* Топбар с информацией о дуэли */
.balda-duel-topbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(0,0,0,0.5);
    padding: 6px 12px;
    border-radius: 8px;
    margin-bottom: 8px;
    border: 1px solid rgba(255,255,255,0.1);
}

.balda-turn-status {
    font-size: 14px;
    font-weight: 900;
    text-transform: uppercase;
    color: #94a3b8;
}
.balda-turn-status.my-turn {
    color: #22c55e;
    text-shadow: 0 0 5px rgba(34, 197, 94, 0.5);
}

.balda-player-timer {
    font-family: monospace;
    font-size: 16px;
    font-weight: bold;
    color: #cbd5e1;
}

/* Оверлей для зрителей */
.balda-spectator-overlay {
    position: absolute;
    inset: 0;
    background: rgba(15, 23, 42, 0.85);
    z-index: 5000;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white;
    text-align: center;
    padding: 20px;
}

/* Попап Неактивности */
.balda-afk-popup {
    position: absolute;
    top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: #1e293b;
    border: 2px solid #fbbf24;
    border-radius: 12px;
    padding: 20px;
    z-index: 6000;
    width: 80%;
    text-align: center;
    box-shadow: 0 10px 30px rgba(0,0,0,0.8);
}
.balda-afk-popup h3 { margin: 0 0 10px 0; color: #fbbf24; }
.balda-afk-popup p { color: #cbd5e1; margin-bottom: 15px; font-size: 14px; }
.balda-afk-btns { display: flex; gap: 10px; }

/* --- ПОДСВЕТКА ХОДА ОППОНЕНТА --- */
.balda-cell.opponent-path {
  background: #f97316; /* Яркий оранжевый */
  color: #fff;
  box-shadow: 0 4px 0 #c2410c, inset 0 0 10px rgba(255,255,255,0.3);
  transform: translateY(2px);
  z-index: 5;
}

.balda-input.opponent-word {
  color: #f97316;
  text-shadow: 0 0 10px rgba(249, 115, 22, 0.4);
  border-color: #f97316;
}

.balda-input.status-win {
  color: #22c55e;
  border-color: #22c55e;
  text-shadow: 0 0 10px rgba(34, 197, 94, 0.4);
}
.balda-input.status-lose {
  color: #ef4444;
  border-color: #ef4444;
  text-shadow: 0 0 10px rgba(239, 68, 68, 0.4);
}

/* --- ОДНОСТРОЧНЫЙ ДИЗАЙН ДУЭЛЬНОЙ ПАНЕЛИ (С ФОНОВЫМ ВЫДЕЛЕНИЕМ И ТУМАНОМ) --- */
.balda-header-duel-inline {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background: rgba(0, 0, 0, 0.2); /* Темная основа (заглушка) всей панели */
    border-radius: 8px; /* Скругляем саму панель */
    overflow: hidden; /* Чтобы выделение половинок не торчало за углы */
    border: 1px solid rgba(255, 255, 255, 0.05); /* Еле заметная общая рамка */
    transition: background 0.3s ease;
}

/* Если 3+ игроков и мой ход - вся панель целиком получает светлый фон */
.balda-header-duel-inline.full-active {
    background: rgba(255, 255, 255, 0.12); /* Светлое выделение всей панели */
}

/* Общие стили для половин */
.duel-inline-player {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 15px;
    font-weight: 900;
    color: #cbd5e1;
    transition: background 0.3s ease, opacity 0.3s ease;
    padding: 8px 12px; /* Внутренние отступы в половинах */
    flex: 1 1; /* Каждая половина занимает ровно 50% */

    /* ТУМАННОСТЬ: Неактивный игрок блеклый */
    opacity: 0.5; /* Можете покрутить прозрачность здесь (0.3 - 0.7) */
}

.duel-inline-player.left {
    justify-content: flex-start;
}
.duel-inline-player.right {
    justify-content: flex-end;
}

/* --- АКТИВНЫЙ ИГРОК --- */
.duel-inline-player.active {
    opacity: 1; /* Выходит из тумана (полностью яркий) */
}

/* В режиме Дуэли 1х1 подсвечивается только его половина */
.balda-header-duel-inline.split-mode .duel-inline-player.active {
    background: rgba(255, 255, 255, 0.12); /* Светлый фон (можно сделать светлее, увеличив 0.12) */
}

/* Если играют 3+, правая сторона (с ранком) не должна тускнеть, когда мой ход */
.balda-header-duel-inline.full-active .duel-inline-player.right {
    opacity: 1;
}

/* ИМЯ АКТИВНОГО ИГРОКА: Белое, слегка зеленоватое */
.duel-inline-player.active .dp-name {
    color: #e8f5e9; /* Светло-зеленый (почти белый) цвет. Можно подкрутить на #dcfce7 */
    text-shadow: 0 0 6px rgba(167, 243, 208, 0.3); /* Очень легкое зеленоватое свечение */
}

/* Базовый цвет имени (неактивный) */
.dp-name {
    color: #cbd5e1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 65px; /* Ограничиваем имена, чтобы время и очки влезли 100% */
    transition: color 0.3s ease;
}

.dp-score {
    color: #fbbf24;
    white-space: nowrap;
    display: flex;
    align-items: center;
}

.dp-time {
    font-family: monospace;
    text-align: right;
    min-width: 38px; /* Фиксируем ширину таймера, чтобы не прыгал */
}

.dp-rank {
    color: #94a3b8;
    font-size: 13px;
    white-space: nowrap;
}

/* --- КОМПАКТНЫЕ ОТСТУПЫ В ШТОРКЕ --- */
.balda-drawer-duel-lists {
    display: flex;
    flex-direction: column;
    gap: 8px; /* Сильно уменьшили отступы между игроками */
}

.balda-drawer-player-section {
    background: rgba(255, 255, 255, 0.03);
    border-radius: 8px;
    padding: 8px; /* Компактнее */
    border: 1px solid rgba(255,255,255,0.05);
}

.balda-drawer-player-header {
    display: flex;
    align-items: center;
    gap: 8px; /* Распределяет элементы в линию */
    font-size: 13px;
    color: #cbd5e1;
    margin-bottom: 6px;
    border-bottom: 1px dashed rgba(255,255,255,0.1);
    padding-bottom: 6px;
    white-space: nowrap;
}

.balda-drawer-player-header .dp-time {
    margin-left: auto; /* Прижимает таймер четко вправо, не ломая остальные слова */
}

.dp-count { font-size: 11px; color: #94a3b8; }
.dp-empty { font-size: 12px; font-style: italic; color: #64748b; }`, "",{"version":3,"sources":["webpack://./src/components/arcade/games/balda/Balda.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;;EAEjB,wBAAwB;EACxB,yBAAyB;EACzB,uGAAuG;EACvG,yBAAyB;EACzB,mBAAmB;EACnB,gDAAgD;;EAEhD,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB,EAAE,qBAAqB;AAC3C;;AAEA,uDAAuD;AACvD;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB,EAAE,wBAAwB;EAC7C,kBAAkB,GAAG,kCAAkC;EACvD,8CAA8C;EAC9C,cAAc;EACd,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,YAAY,EAAE,gDAAgD;AAChE;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY,EAAE,2BAA2B;EACzC,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB,EAAE,oCAAoC;;EAE9D,qDAAqD;EACrD,gBAAgB;EAChB,eAAe,EAAE,gBAAgB;EACjC,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;;EAEtB,kEAAkE;EAClE,0DAA0D;AAC5D;;AAEA,2CAA2C;AAC3C;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB,EAAE,kCAAkC;EACxD,kBAAkB;EAClB,mBAAmB,EAAE,4BAA4B;EACjD,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,wDAAwD;AAC1D;;AAEA,2BAA2B;AAC3B;EACE,qBAAqB,EAAE,YAAY;AACrC;AACA;EACE,qBAAqB,EAAE,UAAU;AACnC;AACA;EACE,qBAAqB,EAAE,UAAU;AACnC;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,YAAY,EAAE,iCAAiC;EAC/C,aAAa;EACb,uBAAuB,EAAE,sBAAsB;EAC/C,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,gBAAgB,EAAE,sBAAsB;EACxC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;;EAE1C,yEAAyE;EACzE,WAAW;EACX,eAAe,EAAE,6BAA6B;;EAE9C,2BAA2B;EAC3B,cAAc;EACd,sBAAsB;;EAEtB,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA,SAAS;AACT;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAE,YAAY;EAC/B,sBAAsB;;EAEtB,mBAAmB,EAAE,iBAAiB;EACtC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,eAAe,EAAE,kBAAkB;EACnC,gBAAgB;EAChB,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,2BAA2B,EAAE,cAAc;EAC3C,iDAAiD;EACjD,yBAAiB;UAAjB,iBAAiB;;AAEnB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA,kDAAkD;AAClD;EACE,qCAAqC;EACrC,YAAY;EACZ,gBAAgB;EAChB,eAAe,EAAE,6BAA6B;AAChD;AACA;EACE,eAAe,EAAE,kBAAkB;AACrC;;AAEA;EACE,mBAAmB,EAAE,0BAA0B;EAC/C,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,qBAAqB,EAAE,0BAA0B;AACnD;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;AACpB;AACA,uCAAuC;AACvC;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB,EAAE,kBAAkB;EAC7C,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,mBAAmB,EAAE,0BAA0B;EAC/C,cAAc;EACd,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B,EAAE,wBAAwB;AACvD;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ,EAAE,SAAS;EACnB,gCAAgC;EAChC,UAAU,EAAE,WAAW;EACvB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,cAAc;EACd,uBAAuB;EACvB,gBAAgB,EAAE,wCAAwC;EAC1D,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,mBAAmB;;EAEnB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe,EAAE,+CAA+C;EAChE,yBAAyB;EACzB,WAAW;;EAEX,eAAe;EACf,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB,EAAE,qBAAqB;EAC1C,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;AACb;;AAEA,aAAa;AACb;EACE,WAAW;EACX,mBAAmB;EACnB,wBAAwB;EACxB,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,YAAY;;EAEZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,mDAAmD;AACnD;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,qCAAqC;EACrC,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,gBAAgB,EAAE,uBAAuB;AAC3C;;AAEA,sDAAsD;AACtD;EACE,kBAAkB;EAClB,OAAO;EACP,OAAO;EACP,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;;EAEhB,gEAAgE;EAChE,4BAA4B;;EAE5B,kCAAkC;EAClC,2BAA2B;EAC3B,aAAa;EACb,gCAAgC;EAChC,4BAA4B;EAC5B,uCAAuC;;EAEvC,4BAA4B;EAC5B,wDAAwD;EACxD,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,8CAA8C;EAC9C,0BAA0B;AAC5B;AACA;EACE,qBAAqB;AACvB;;AAEA,wCAAwC;AACxC;IACI,oCAAoC;IACpC,yCAAyC;IACzC,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,+BAA+B;AACnC;AACA,oBAAoB,OAAO,UAAU,EAAE,2BAA2B,EAAE,EAAE,KAAK,UAAU,EAAE,wBAAwB,EAAE,EAAE;;AAEnH;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,gDAAgD;IAChD,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uBAAuB;AAC3B;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;AACA;EACE,gDAAgD;EAChD,WAAW;AACb;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,QAAQ,EAAE,iCAAiC;EAC3C,OAAO,EAAE,QAAQ;EACjB,aAAa;EACb,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,oBAAoB,EAAE,qBAAqB;EAC3C,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB,EAAE,gBAAgB;EACpC,mBAAmB;EACnB,qCAAqC;EACrC,YAAY;EACZ,sCAAsC;EACtC,kCAAkC;EAClC,UAAU;EACV,6EAA6E;;EAE7E,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,KAAK,kCAAkC,EAAE,UAAU,EAAE;AACvD;;AAEA,YAAY,cAAc,EAAE,qBAAqB,EAAE;AACnD,cAAc,cAAc,EAAE,qBAAqB,EAAE;AACrD,iBAAiB,cAAc,EAAE,qBAAqB,EAAE;;AAExD,WAAW;AACX;EACE,WAAW,2BAA2B,EAAE;EACxC,WAAW,0BAA0B,EAAE;EACvC,gBAAgB,2BAA2B,EAAE;EAC7C,WAAW,0BAA0B,EAAE;AACzC;;AAEA,yEAAyE;;AAEzE;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,iBAAiB;EAChC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB,EAAE,gBAAgB;EAC3C,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;EACvC,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ,EAAE,SAAS;EACnB,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA,iBAAiB,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE;AACjE,iBAAiB,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE;;AAEjE;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;AACA,YAAY,cAAc,EAAE,qBAAqB,EAAE;AACnD,cAAc,cAAc,EAAE,qBAAqB,EAAE;;AAErD;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,aAAa,EAAE,uBAAuB,EAAE,mBAAmB;AAC7D;AACA,kBAAkB,gBAAgB,EAAE,cAAc,EAAE;AACpD,oBAAoB,uBAAuB,EAAE,sBAAsB,EAAE,WAAW,EAAE;;AAElF,kEAAkE;AAClE;EACE,0BAA0B;AAC5B;;AAEA,wEAAwE;AACxE;EACE,WAAW,6BAA6B,EAAE;EAC1C,WAAW,4BAA4B,EAAE;EACzC,gBAAgB,2BAA2B,EAAE;EAC7C,WAAW,0BAA0B,EAAE;AACzC;;AAEA,mCAAmC;AACnC;IACI,KAAK,0EAA0E,EAAE;IACjF,MAAM,+EAA+E,EAAE,qBAAqB,EAAE;IAC9G,OAAO,0EAA0E,EAAE;AACvF;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,qFAAqF;IACrF,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,oBAAoB;IACpB,sCAAsC;IACtC,8EAA8E;AAClF;;AAEA;IACI,KAAK,UAAU,EAAE,4CAA4C,EAAE;IAC/D,MAAM,UAAU,EAAE,sCAAsC,EAAE;IAC1D,MAAM,UAAU,EAAE,sCAAsC,EAAE;IAC1D,OAAO,UAAU,EAAE,2CAA2C,EAAE;AACpE;;AAEA,qBAAqB;;AAErB,iCAAiC;AACjC;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,cAAc;IACd,2CAA2C;AAC/C;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,QAAQ;IACR,kCAAkC;IAClC,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,aAAa;AACjB;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,QAAQ,EAAE,SAAS;IACnB,gCAAgC;IAChC,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,uCAAuC;AAC3C;AACA,sBAAsB,kBAAkB,EAAE,cAAc,EAAE;AAC1D,qBAAqB,cAAc,EAAE,mBAAmB,EAAE,eAAe,EAAE;AAC3E,kBAAkB,aAAa,EAAE,SAAS,EAAE;;AAE5C,qCAAqC;AACrC;EACE,mBAAmB,EAAE,oBAAoB;EACzC,WAAW;EACX,iEAAiE;EACjE,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,4CAA4C;AAC9C;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,iFAAiF;AACjF;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,8BAA8B,EAAE,yCAAyC;IACzE,kBAAkB,EAAE,0BAA0B;IAC9C,gBAAgB,EAAE,iDAAiD;IACnE,2CAA2C,EAAE,6BAA6B;IAC1E,gCAAgC;AACpC;;AAEA,wEAAwE;AACxE;IACI,qCAAqC,EAAE,kCAAkC;AAC7E;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mDAAmD;IACnD,iBAAiB,EAAE,mCAAmC;IACtD,SAAO,EAAE,uCAAuC;;IAEhD,yCAAyC;IACzC,YAAY,EAAE,oDAAoD;AACtE;;AAEA;IACI,2BAA2B;AAC/B;AACA;IACI,yBAAyB;AAC7B;;AAEA,2BAA2B;AAC3B;IACI,UAAU,EAAE,wCAAwC;AACxD;;AAEA,0DAA0D;AAC1D;IACI,qCAAqC,EAAE,uDAAuD;AAClG;;AAEA,gFAAgF;AAChF;IACI,UAAU;AACd;;AAEA,oDAAoD;AACpD;IACI,cAAc,EAAE,mEAAmE;IACnF,6CAA6C,EAAE,sCAAsC;AACzF;;AAEA,oCAAoC;AACpC;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe,EAAE,uDAAuD;IACxE,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,eAAe,EAAE,8CAA8C;AACnE;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA,wCAAwC;AACxC;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ,EAAE,4CAA4C;AAC1D;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,YAAY,EAAE,eAAe;IAC7B,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ,EAAE,kCAAkC;IAC5C,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,+CAA+C;IAC/C,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB,EAAE,4DAA4D;AACnF;;AAEA,YAAY,eAAe,EAAE,cAAc,EAAE;AAC7C,YAAY,eAAe,EAAE,kBAAkB,EAAE,cAAc,EAAE","sourcesContent":["/* games/balda/Balda.css */\n\n.balda-board {\n  position: fixed;\n  top: 10px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 98%;\n  max-width: 400px;\n  height: calc(100% - 20px);\n  max-height: 850px;\n\n  /* Фон как в Словоделе */\n  background-color: #1a1a2e;\n  background-image: radial-gradient(circle at center, rgba(30, 41, 59, 0.8) 0%, rgba(15, 23, 42, 1) 100%);\n  border: 4px solid #334155;\n  border-radius: 16px;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);\n\n  display: flex;\n  flex-direction: column;\n  padding: 10px;\n  box-sizing: border-box;\n  z-index: 6000;\n  font-family: 'Courier New', monospace;\n  overflow: hidden;\n  user-select: none;\n  touch-action: none; /* Блокируем скролл */\n}\n\n/* ОБНОВЛЕННЫЙ HEADER (Возвращаем плотное прилегание) */\n.balda-header {\n  position: relative;\n  z-index: 7001;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 0px; /* Как было изначально */\n  margin-bottom: 0px;  /* Убрали отступ - щель исчезнет */\n  border-bottom: 1px solid rgba(255,255,255,0.1);\n  flex-shrink: 0;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.balda-header:active {\n  opacity: 0.7; /* Легкая прозрачность при нажатии вместо фона */\n}\n\n.balda-title {\n  font-size: 18px;\n  font-weight: 900;\n  color: #fbbf24;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  text-shadow: 0 0 10px rgba(251, 191, 36, 0.3);\n}\n\n.balda-stats {\n  display: flex;\n  gap: 12px;\n  font-size: 16px;\n  font-weight: bold;\n  color: #cbd5e1;\n}\n\n/* INPUT AREA */\n.balda-input-wrapper {\n  position: relative;\n  width: 100%;\n  height: 46px; /* Чуть выше для комфорта */\n  flex-shrink: 0;\n  margin-bottom: 3px;\n  display: flex;\n  justify-content: center;\n}\n\n.balda-input {\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.4);\n  border: 2px solid #334155;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 5px 10px 0 10px; /* Чтобы текст не прилипал к краям */\n\n  /* СТИЛИ ПО УМОЛЧАНИЮ (ДЛЯ СЛОВА) - КРУПНЫЕ И ЯРКИЕ */\n  color: #ffffffdf;\n  font-size: 28px; /* Еще крупнее */\n  font-weight: 900;\n  letter-spacing: 3px;\n  text-transform: uppercase;\n  box-sizing: border-box;\n\n  /* ИСПРАВЛЕНИЕ: Убрали 'all' чтобы размер шрифта не анимировался */\n  transition: border-color 0.2s, background 0.2s, color 0.1s;\n}\n\n/* СТИЛИ ДЛЯ ПОДСКАЗКИ (МЕЛКИЕ И БЛЕКЛЫЕ) */\n.balda-input.is-hint {\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 15px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  text-transform: none; /* Обычный регистр для подсказок */\n  font-style: italic;\n  white-space: normal; /* Разрешаем перенос строк */\n  line-height: 1.2;\n}\n\n/* ОБЩИЙ КЛАСС АНИМАЦИИ */\n.balda-grid.shake {\n  animation: shake 0.4s cubic-bezier(.36,.07,.19,.97) both;\n}\n\n/* ЦВЕТА РАМОК ПРИ ТРЯСКЕ */\n.balda-grid.shake.shake-error {\n  border-color: #ef4444; /* Красный */\n}\n.balda-grid.shake.shake-warning {\n  border-color: #1d4ed8; /* Синий */\n}\n.balda-grid.shake.shake-neutral {\n  border-color: #94a3b8; /* Серый */\n}\n\n.balda-hint-text {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.4);\n  font-style: italic;\n  font-weight: normal;\n  letter-spacing: 0;\n}\n\n/* GRID CONTAINER */\n.balda-grid-wrapper {\n  flex-grow: 1; /* Занимает всё доступное место */\n  display: flex;\n  align-items: flex-start; /* Прижимаем к верху */\n  justify-content: center;\n  position: relative;\n  width: 100%;\n  overflow: hidden; /* Чтобы не вылезало */\n  margin-top: 5px;\n}\n\n.balda-grid {\n  display: grid;\n  gap: 6px;\n  background: #0f172a;\n  padding: 8px;\n  border-radius: 12px;\n  border: 2px solid #334155;\n  box-shadow: inset 0 0 30px rgba(0,0,0,0.6);\n\n  /* Логика размеров: занимаем 100% ширины, но не больше доступной высоты */\n  width: 100%;\n  max-width: 100%; /* Ограничивается родителем */\n\n  /* Центрируем внутри себя */\n  margin: 0 auto;\n  box-sizing: border-box;\n\n  /* Плавность смены цвета рамки */\n  transition: border-color 0.2s;\n}\n\n/* CELL */\n.balda-cell {\n  width: 100%;\n  height: 100%;\n  aspect-ratio: 1/1; /* Квадрат */\n  box-sizing: border-box;\n\n  background: #334155; /* Базовый цвет */\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  font-size: 28px; /* Крупный шрифт */\n  font-weight: 900;\n  color: #f8fafc;\n\n  cursor: pointer;\n  position: relative;\n  box-shadow: 0 4px 0 #1e293b; /* 3D эффект */\n  transition: transform 0.1s, background-color 0.1s;\n  user-select: none;\n  \n}\n\n.balda-cell:active {\n  transform: translateY(2px);\n  box-shadow: 0 2px 0 #1e293b;\n}\n\n/* Cell States */\n.balda-cell.empty {\n  background: rgba(255, 255, 255, 0.05);\n  box-shadow: inset 0 2px 4px rgba(0,0,0,0.3);\n  border: 2px dashed rgba(255,255,255,0.13);\n}\n\n/* СОСТОЯНИЕ: Недоступное пустое поле (скрываем) */\n.balda-cell.hidden {\n  background: rgba(255, 255, 255, 0.05);\n  border: none;\n  box-shadow: none;\n  cursor: default; /* Не кликабельно визуально */\n}\n.balda-cell.hidden:active {\n  transform: none; /* Не нажимается */\n}\n\n.balda-cell.temp {\n  background: #3b82f6; /* Синий для новой буквы */\n  box-shadow: 0 4px 0 #1d4ed8;\n  z-index: 2;\n}\n\n.balda-cell.selected {\n  background: #bfd9fa80; /* Золотой для выделения */\n}\n\n/* --- НОВОЕ: Подсветка последнего хода --- */\n.balda-cell.last-move {\n  position: relative;\n}\n/* Добавляем цветной уголок или рамку */\n.balda-cell.last-move::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px solid #22c55e; /* Зеленая рамка */\n  border-radius: 6px;\n  opacity: 0.6;\n  pointer-events: none;\n  box-shadow: inset 0 0 5px rgba(34, 197, 94, 0.4);\n}\n\n.balda-cell.path {\n  background: #fbbf24; /* Золотой для выделения */\n  color: #0f172a;\n  box-shadow: 0 4px 0 #b45309;\n  transform: translateY(2px);\n  box-shadow: 0 1px 0 #b45309; /* \"Нажатое\" состояние */\n}\n\n/* Подсветка последнего (головы пути) */\n.balda-cell.head::after {\n  content: '';\n  position: absolute;\n  top: 50%; left: 50%;\n  transform: translate(-50%, -50%);\n  width: 50%; height: 50%;\n  background: rgba(255,255,255,0.3);\n  border-radius: 50%;\n}\n\n/* BOTTOM AREA (Controls or Keyboard) */\n.balda-bottom-area {\n  flex-shrink: 0;\n  background: transparent;\n  min-height: 50px; /* Чтобы не прыгало при смене контента */\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  margin-top: 1px;\n}\n\n/* CONTROLS (Кнопки действий) */\n.balda-controls {\n  display: flex;\n  gap: 12px;\n  width: 100%;\n}\n\n.balda-btn {\n  /* ТЕПЕРЬ ОБЕ КНОПКИ ТЯНУТСЯ */\n  flex: 1;\n  height: 50px;\n  border: none;\n  border-radius: 10px;\n\n  font-family: inherit;\n  font-weight: 900;\n  font-size: 16px; /* Чуть меньше шрифт, чтобы влезло \"Отменить\" */\n  text-transform: uppercase;\n  color: #fff;\n\n  cursor: pointer;\n  box-shadow: 0 5px 0 rgba(0,0,0,0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  transition: all 0.1s;\n}\n\n.balda-btn:active {\n  transform: translateY(3px);\n  box-shadow: 0 2px 0 rgba(0,0,0,0.3);\n}\n\n.balda-btn:disabled {\n  opacity: 0.5;\n  filter: grayscale(1);\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.btn-cancel {\n  background: #334155; /* Серый slate цвет */\n  box-shadow: 0 5px 0 #1e293b;\n  /* Убрали flex: 0 0 ... */\n}\n\n.btn-submit {\n  background: #22c55e;\n  box-shadow: 0 5px 0 #15803d;\n  color: #fff;\n}\n\n/* KEYBOARD */\n.balda-keyboard {\n  width: 100%;\n  border-radius: 12px;\n  padding: 0px 0px 8px 0px;\n  box-sizing: border-box;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 4px;\n  animation: slideUp 0.2s ease-out;\n}\n\n@keyframes slideUp {\n  from { transform: translateY(20px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.kb-key {\n  /* Адаптивная ширина клавиш */\n  flex: 1 0 8%;\n  max-width: 9%;\n  height: 42px;\n\n  background: #f1f5f9;\n  color: #0f172a;\n  border-radius: 6px;\n  font-weight: 800;\n  font-size: 18px;\n  border: none;\n  box-shadow: 0 3px 0 #cbd5e1;\n  cursor: pointer;\n  display: flex; align-items: center; justify-content: center;\n  padding: 0;\n}\n\n.kb-key:active {\n  transform: translateY(2px);\n  box-shadow: 0 1px 0 #cbd5e1;\n}\n\n.kb-key.empty {\n  background: transparent;\n  box-shadow: none;\n  cursor: default;\n}\n\n/* --- ВОЗВРАТ К ОРИГИНАЛЬНОМУ ДИЗАЙНУ ЯЗЫЧКА --- */\n.balda-drawer-trigger {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin-bottom: -12px;\n  cursor: pointer;\n  flex-shrink: 0;\n  z-index: 1000;\n}\n\n.balda-drawer-btn-small {\n  background: #334155;\n  color: #fbbf24;\n  border: 1px solid #475569;\n  border-top: none;\n  border-radius: 0 0 12px 12px;\n  padding: 2px 20px;\n  font-size: 16px;\n  cursor: pointer;\n  box-shadow: 0 4px 6px rgba(0,0,0,0.3);\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.balda-drawer-btn-small:hover {\n  background: #475569;\n  padding-top: 5px; /* Эффект вытягивания */\n}\n\n/* ОБНОВЛЕННАЯ ШТОРКА (Уменьшили внутренние отступы) */\n.balda-drawer {\n  position: absolute;\n  top: 30;\n  left: 0;\n  width: 100%;\n  height: auto;\n  min-height: 50%;\n  max-height: 100%;\n\n  /* Верхний отступ ровно под высоту однострочного хедера (35px) */\n  padding: 35px 10px 10px 10px;\n\n  background: rgba(15, 23, 42, 0.98);\n  backdrop-filter: blur(10px);\n  z-index: 7000;\n  border-bottom: 4px solid #fbbf24;\n  border-radius: 0 0 16px 16px;\n  box-shadow: 0 20px 50px rgba(0,0,0,0.8);\n\n  transform: translateY(-120%);\n  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n}\n\n.balda-drawer.open {\n  transform: translateY(20px);\n}\n\n.balda-drawer-content {\n  flex-grow: 1;\n  overflow-y: auto;\n  padding-right: 5px;\n  margin-bottom: 10px;\n  /* Скроллбар */\n  scrollbar-width: thin;\n  scrollbar-color: #334155 transparent;\n}\n\n.balda-drawer-footer {\n  flex-shrink: 0;\n  display: flex;\n  justify-content: center;\n  padding-top: 10px;\n  border-top: 1px solid rgba(255,255,255,0.1);\n}\n\n.balda-close-drawer-btn {\n  background: #fbbf24;\n  color: #0f172a;\n  border: none;\n  border-radius: 50%;\n  width: 48px;\n  height: 48px;\n  font-size: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: 0 4px 10px rgba(251, 191, 36, 0.4);\n  transition: transform 0.2s;\n}\n.balda-close-drawer-btn:active {\n  transform: scale(0.9);\n}\n\n/* Компактная панель определения слова */\n.balda-definition-panel {\n    background: rgba(251, 191, 36, 0.12);\n    border: 1px solid rgba(251, 191, 36, 0.3);\n    border-radius: 8px;\n    padding: 8px 10px;\n    margin-bottom: 10px;\n    cursor: pointer;\n    animation: fadeIn 0.3s ease-out;\n}\n@keyframes fadeIn { from { opacity: 0; transform: translateY(-5px); } to { opacity: 1; transform: translateY(0); } }\n\n.balda-def-word {\n    display: block;\n    font-weight: 900;\n    color: #fbbf24;\n    text-transform: uppercase;\n    font-size: 15px;\n    margin-bottom: 4px;\n    border-bottom: 1px solid rgba(251, 191, 36, 0.2);\n    padding-bottom: 2px;\n}\n.balda-def-text {\n    font-size: 13px;\n    line-height: 1.5;\n    color: #f1f5f9;\n    font-family: sans-serif;\n}\n.balda-empty-list {\n  text-align: center;\n  color: #64748b;\n  font-style: italic;\n  margin-top: 40px;\n}\n\n.balda-words-cloud {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-content: flex-start;\n}\n\n.balda-word-tag {\n  background: rgba(255, 255, 255, 0.05);\n  color: #e2e8f0;\n  padding: 6px 10px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  border: 1px solid transparent;\n  transition: all 0.2s;\n}\n.balda-word-tag:hover {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255,255,255,0.2);\n}\n.balda-word-tag.has-def {\n  border-bottom: 1px solid rgba(251, 191, 36, 0.5);\n  color: #fff;\n}\n.balda-word-help-icon {\n  font-size: 10px;\n  color: #fbbf24;\n  margin-left: 6px;\n  opacity: 0.8;\n}\n\n/* --- ПЕЧАТИ (STAMPS) --- */\n.balda-stamp-overlay {\n  position: absolute;\n  top: 15%; /* Подняли выше (верхняя треть) */\n  left: 0; right: 0;\n  height: 100px;\n  display: flex; align-items: center; justify-content: center;\n  pointer-events: none; /* Пропускает клики */\n  background: transparent;\n  z-index: 100;\n}\n\n.balda-stamp {\n  /* УВЕЛИЧЕНО В ~1.5 РАЗА */\n  padding: 15px 30px;\n  font-size: 34px;\n  font-weight: 900;\n  text-transform: uppercase;\n  border: 8px double; /* Рамка толще */\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.85);\n  opacity: 0.8;\n  box-shadow: 0 6px 20px rgba(0,0,0,0.3);\n  transform: rotate(-10deg) scale(2);\n  opacity: 0;\n  animation: baldaStampIn 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;\n\n  text-align: center;\n  white-space: pre-wrap;\n  max-width: 90%;\n  line-height: 1.1;\n}\n\n@keyframes baldaStampIn {\n  to { transform: rotate(-10deg) scale(1); opacity: 1; }\n}\n\n.stamp-ok { color: #15803d; border-color: #15803d; }\n.stamp-fail { color: #b91c1c; border-color: #b91c1c; }\n.stamp-warning { color: #1d4ed8; border-color: #1d4ed8; }\n\n/* Tряска */\n@keyframes shake {\n  10%, 90% { transform: translateX(-2px); }\n  20%, 80% { transform: translateX(4px); }\n  30%, 50%, 70% { transform: translateX(-6px); }\n  40%, 60% { transform: translateX(6px); }\n}\n\n/* Добавить в конец файла, если стили отчета не подтягиваются глобально */\n\n.tr-report-overlay {\n  position: absolute;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background: rgba(0, 0, 0, 0.85);\n  backdrop-filter: blur(5px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 8000; /* Поверх всего */\n  animation: fadeIn 0.3s ease-out;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.tr-report-card {\n  width: 100%;\n  max-width: 360px;\n  background-color: #f0e6cf; /* Стиль папки */\n  padding: 30px 25px;\n  border-radius: 4px;\n  box-shadow: 0 20px 50px rgba(0,0,0,0.8);\n  transform: rotate(-1deg);\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  color: #222;\n}\n\n.tr-watermark {\n  position: absolute;\n  top: 50%; left: 50%;\n  transform: translate(-50%, -50%) rotate(-45deg);\n  font-size: 60px;\n  font-weight: 900;\n  color: rgba(0,0,0,0.05);\n  pointer-events: none;\n  white-space: nowrap;\n}\n\n.tr-report-header {\n  border-bottom: 3px solid #333;\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n  text-align: center;\n}\n\n.tr-report-title {\n  font-size: 24px;\n  font-weight: 900;\n  text-transform: uppercase;\n  color: #1a1a1a;\n}\n\n.tr-stats-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.tr-stat-row {\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid rgba(0,0,0,0.1);\n  padding-bottom: 4px;\n}\n\n.tr-stat-label { font-size: 13px; font-weight: 700; color: #666; }\n.tr-stat-value { font-size: 20px; font-weight: 900; color: #111; }\n\n.tr-result-stamp {\n  margin: 10px auto;\n  padding: 8px 20px;\n  font-size: 28px;\n  font-weight: 900;\n  text-transform: uppercase;\n  border: 5px double;\n  border-radius: 8px;\n  transform: rotate(-10deg);\n  opacity: 0.9;\n  align-self: center;\n}\n.stamp-ok { color: #15803d; border-color: #15803d; }\n.stamp-fail { color: #b91c1c; border-color: #b91c1c; }\n\n.tr-btn-group {\n  margin-top: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.tr-btn {\n  border: none;\n  padding: 14px 0;\n  width: 100%;\n  font-weight: 900;\n  text-transform: uppercase;\n  cursor: pointer;\n  border-radius: 4px;\n  display: flex; justify-content: center; align-items: center;\n}\n.tr-btn-primary { background: #222; color: #f0e6cf; }\n.tr-btn-secondary { background: transparent; border: 2px solid #444; color: #333; }\n\n/* Переопределяем анимацию только для серой (нейтральной) тряски */\n.balda-grid.shake.shake-neutral {\n  animation-name: shake-soft;\n}\n\n/* Новая мягкая анимация (амплитуда уменьшена в ~3 раза: с 6px до 2px) */\n@keyframes shake-soft {\n  10%, 90% { transform: translateX(-0.5px); }\n  20%, 80% { transform: translateX(0.5px); }\n  30%, 50%, 70% { transform: translateX(-1px); }\n  40%, 60% { transform: translateX(1px); }\n}\n\n/* Вспышка поля при передаче хода */\n@keyframes myTurnFlash {\n    0% { box-shadow: inset 0 0 30px rgba(0,0,0,0.6), 0 0 0 0px rgba(34, 197, 94, 0); }\n    50% { box-shadow: inset 0 0 30px rgba(0,0,0,0.6), 0 0 20px 5px rgba(34, 197, 94, 0.8); border-color: #22c55e; }\n    100% { box-shadow: inset 0 0 30px rgba(0,0,0,0.6), 0 0 0 0px rgba(34, 197, 94, 0); }\n}\n\n.balda-grid.my-turn-flash {\n    animation: myTurnFlash 1s ease-out;\n}\n\n.balda-turn-toast {\n    position: absolute;\n    top: 20%;\n    left: 50%;\n    transform: translateX(-50%);\n    background: linear-gradient(90deg, transparent, rgba(34, 197, 94, 0.95), transparent);\n    color: white;\n    padding: 10px 60px;\n    font-size: 24px;\n    font-weight: 900;\n    letter-spacing: 2px;\n    z-index: 4000;\n    pointer-events: none;\n    text-shadow: 0 2px 5px rgba(0,0,0,0.8);\n    animation: turnToastAnim 1.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;\n}\n\n@keyframes turnToastAnim {\n    0% { opacity: 0; transform: translate(-50%, -30px) scale(0.8); }\n    20% { opacity: 1; transform: translate(-50%, 0) scale(1); }\n    80% { opacity: 1; transform: translate(-50%, 0) scale(1); }\n    100% { opacity: 0; transform: translate(-50%, 20px) scale(0.8); }\n}\n\n/* DUEL MODE STYLES */\n\n/* Топбар с информацией о дуэли */\n.balda-duel-topbar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: rgba(0,0,0,0.5);\n    padding: 6px 12px;\n    border-radius: 8px;\n    margin-bottom: 8px;\n    border: 1px solid rgba(255,255,255,0.1);\n}\n\n.balda-turn-status {\n    font-size: 14px;\n    font-weight: 900;\n    text-transform: uppercase;\n    color: #94a3b8;\n}\n.balda-turn-status.my-turn {\n    color: #22c55e;\n    text-shadow: 0 0 5px rgba(34, 197, 94, 0.5);\n}\n\n.balda-player-timer {\n    font-family: monospace;\n    font-size: 16px;\n    font-weight: bold;\n    color: #cbd5e1;\n}\n\n/* Оверлей для зрителей */\n.balda-spectator-overlay {\n    position: absolute;\n    inset: 0;\n    background: rgba(15, 23, 42, 0.85);\n    z-index: 5000;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    text-align: center;\n    padding: 20px;\n}\n\n/* Попап Неактивности */\n.balda-afk-popup {\n    position: absolute;\n    top: 50%; left: 50%;\n    transform: translate(-50%, -50%);\n    background: #1e293b;\n    border: 2px solid #fbbf24;\n    border-radius: 12px;\n    padding: 20px;\n    z-index: 6000;\n    width: 80%;\n    text-align: center;\n    box-shadow: 0 10px 30px rgba(0,0,0,0.8);\n}\n.balda-afk-popup h3 { margin: 0 0 10px 0; color: #fbbf24; }\n.balda-afk-popup p { color: #cbd5e1; margin-bottom: 15px; font-size: 14px; }\n.balda-afk-btns { display: flex; gap: 10px; }\n\n/* --- ПОДСВЕТКА ХОДА ОППОНЕНТА --- */\n.balda-cell.opponent-path {\n  background: #f97316; /* Яркий оранжевый */\n  color: #fff;\n  box-shadow: 0 4px 0 #c2410c, inset 0 0 10px rgba(255,255,255,0.3);\n  transform: translateY(2px);\n  z-index: 5;\n}\n\n.balda-input.opponent-word {\n  color: #f97316;\n  text-shadow: 0 0 10px rgba(249, 115, 22, 0.4);\n  border-color: #f97316;\n}\n\n.balda-input.status-win {\n  color: #22c55e;\n  border-color: #22c55e;\n  text-shadow: 0 0 10px rgba(34, 197, 94, 0.4);\n}\n.balda-input.status-lose {\n  color: #ef4444;\n  border-color: #ef4444;\n  text-shadow: 0 0 10px rgba(239, 68, 68, 0.4);\n}\n\n/* --- ОДНОСТРОЧНЫЙ ДИЗАЙН ДУЭЛЬНОЙ ПАНЕЛИ (С ФОНОВЫМ ВЫДЕЛЕНИЕМ И ТУМАНОМ) --- */\n.balda-header-duel-inline {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    background: rgba(0, 0, 0, 0.2); /* Темная основа (заглушка) всей панели */\n    border-radius: 8px; /* Скругляем саму панель */\n    overflow: hidden; /* Чтобы выделение половинок не торчало за углы */\n    border: 1px solid rgba(255, 255, 255, 0.05); /* Еле заметная общая рамка */\n    transition: background 0.3s ease;\n}\n\n/* Если 3+ игроков и мой ход - вся панель целиком получает светлый фон */\n.balda-header-duel-inline.full-active {\n    background: rgba(255, 255, 255, 0.12); /* Светлое выделение всей панели */\n}\n\n/* Общие стили для половин */\n.duel-inline-player {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 15px;\n    font-weight: 900;\n    color: #cbd5e1;\n    transition: background 0.3s ease, opacity 0.3s ease;\n    padding: 8px 12px; /* Внутренние отступы в половинах */\n    flex: 1; /* Каждая половина занимает ровно 50% */\n\n    /* ТУМАННОСТЬ: Неактивный игрок блеклый */\n    opacity: 0.5; /* Можете покрутить прозрачность здесь (0.3 - 0.7) */\n}\n\n.duel-inline-player.left {\n    justify-content: flex-start;\n}\n.duel-inline-player.right {\n    justify-content: flex-end;\n}\n\n/* --- АКТИВНЫЙ ИГРОК --- */\n.duel-inline-player.active {\n    opacity: 1; /* Выходит из тумана (полностью яркий) */\n}\n\n/* В режиме Дуэли 1х1 подсвечивается только его половина */\n.balda-header-duel-inline.split-mode .duel-inline-player.active {\n    background: rgba(255, 255, 255, 0.12); /* Светлый фон (можно сделать светлее, увеличив 0.12) */\n}\n\n/* Если играют 3+, правая сторона (с ранком) не должна тускнеть, когда мой ход */\n.balda-header-duel-inline.full-active .duel-inline-player.right {\n    opacity: 1;\n}\n\n/* ИМЯ АКТИВНОГО ИГРОКА: Белое, слегка зеленоватое */\n.duel-inline-player.active .dp-name {\n    color: #e8f5e9; /* Светло-зеленый (почти белый) цвет. Можно подкрутить на #dcfce7 */\n    text-shadow: 0 0 6px rgba(167, 243, 208, 0.3); /* Очень легкое зеленоватое свечение */\n}\n\n/* Базовый цвет имени (неактивный) */\n.dp-name {\n    color: #cbd5e1;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 65px; /* Ограничиваем имена, чтобы время и очки влезли 100% */\n    transition: color 0.3s ease;\n}\n\n.dp-score {\n    color: #fbbf24;\n    white-space: nowrap;\n    display: flex;\n    align-items: center;\n}\n\n.dp-time {\n    font-family: monospace;\n    text-align: right;\n    min-width: 38px; /* Фиксируем ширину таймера, чтобы не прыгал */\n}\n\n.dp-rank {\n    color: #94a3b8;\n    font-size: 13px;\n    white-space: nowrap;\n}\n\n/* --- КОМПАКТНЫЕ ОТСТУПЫ В ШТОРКЕ --- */\n.balda-drawer-duel-lists {\n    display: flex;\n    flex-direction: column;\n    gap: 8px; /* Сильно уменьшили отступы между игроками */\n}\n\n.balda-drawer-player-section {\n    background: rgba(255, 255, 255, 0.03);\n    border-radius: 8px;\n    padding: 8px; /* Компактнее */\n    border: 1px solid rgba(255,255,255,0.05);\n}\n\n.balda-drawer-player-header {\n    display: flex;\n    align-items: center;\n    gap: 8px; /* Распределяет элементы в линию */\n    font-size: 13px;\n    color: #cbd5e1;\n    margin-bottom: 6px;\n    border-bottom: 1px dashed rgba(255,255,255,0.1);\n    padding-bottom: 6px;\n    white-space: nowrap;\n}\n\n.balda-drawer-player-header .dp-time {\n    margin-left: auto; /* Прижимает таймер четко вправо, не ломая остальные слова */\n}\n\n.dp-count { font-size: 11px; color: #94a3b8; }\n.dp-empty { font-size: 12px; font-style: italic; color: #64748b; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
